import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';

import { historyType } from '../../services/type';

type DescriptionProps = Pick<historyType, 'description'>;

export default function Description({ description }: DescriptionProps) {
  return (
    <Container>
      <Heading
        type={HEADING_TYPE.H2}
        className='text-lg font-medium leading-9  text-[#424244]'
      >
        {description.title}
      </Heading>
      {description?.subTitle?.map((item,index) => {
        return (
          <Text
          key={index}
            type={TEXT_TYPE.P}
            className='mt-2 text-sm font-light leading-6 tracking-tighter text-[#76767C]'
          >
            {item}
          </Text>
        );
      })}
    </Container>
  );
}
